export enum ModuleConfigEnum {
  DP_TEMPLATE_DEFINITIONS,
  DP_TEMPLATE_ELIGIBLE_DIV_BRANDS,
  DP_TEMPLATES_ENABLE
}
